// require('./run')
require('./ilt')
require('./ilt-plan-vs-target')
require('./metadata')

var deleteAnnotation = async function(uid) {
    fetch("/services/plugin-annotations/annotations/"+uid, {
      "headers": {
        "accept": "*/*",
        "content-type": "application/json",
      },
      "body": null,
      "method": "DELETE",
    })
}

var createAnnotations = async function(annots) {
  for (let i = 0; i < annots.length; i++) {
      await fetch("/services/plugin-annotations/annotations/", {
        "headers": {
          "accept": "*/*",
          "content-type": "application/json",
        },
        "body": JSON.stringify(annots[i]),
        "method": "POST",
      });
  }
}

try {
    window['annotationUtils'] = {}
    window['annotationUtils']['deleteAnnotation'] = deleteAnnotation
    window['annotationUtils']['createAnnotations'] = createAnnotations
} catch (e) {
    console.error(e)
}